<h2 mat-dialog-title>Speichert</h2>
<div mat-dialog-content>
  <mat-spinner></mat-spinner>
</div>
